import AclAccountEntity from '@/entities/AclAccountEntity';
import Repository from '@/services/Repository';
import Api from '@/services/Api';

export default class AclManagement {

    private repository: Repository;
    private api: Api;

    constructor(repository: Repository, api: Api) {
        this.repository = repository;
        this.api = api;
    }

    public async loadAccounts(): Promise<void> {
        this.repository.aclAccounts = await this.api.getAclAccounts();
    }

    public getAccounts(): AclAccountEntity[] {
        return this.repository.aclAccounts;
    }

    public async deleteAccount(id: string): Promise<void> {
        await this.api.deleteAclAccount(id);
        const index = this.repository.aclAccounts.findIndex((account: AclAccountEntity): boolean => {
            return account.id === id;
        });
        this.repository.aclAccounts.splice(index, 1);
    }
}